import { createStore } from 'owa-satcheljs';
import type { PresenceRecord } from './PresenceRecord';

interface PresenceStore {
    presences: Map<string, PresenceRecord>;
    isLicenseEnabled?: boolean;
}

export const presenceStore: () => PresenceStore = createStore<PresenceStore>(
    'personaPresenceStore',
    {
        presences: new Map(),
        isLicenseEnabled: undefined,
    }
);
